import {
    getField,
    updateField
} from 'vuex-map-fields';
import DEFINES from '@/defines';
import * as API from '@/api';
import i18n from '@/i18n';

function initialState() {
  return {
    film_genre: null,
    film_media: null,
    film_format: null,
    film_rights: null,
    film_type: null,
    languages: null,
    territories: null,
    film_countries: null,
    film_contract_type: [
      {
        name: i18n.t ('rms.film_contract_type_exclusive_label'),
        id: 1,
      },
      {
        name: i18n.t ('rms.film_contract_type_non_exclusive_label'),
        id: 0,
      },
    ],
    film_release_year: [
      {
        name: i18n.t ('rms.film_released_date.this_year_label'),
        id: new Date ().getFullYear (),
      },
      {
        name: i18n.t ('rms.film_released_date.previous_year_label'),
        id: new Date ().getFullYear () - 1,
      },
      {
        name: i18n.t ('rms.film_released_date.two_years_ago_label'),
        id: new Date ().getFullYear () - 2,
      },
      {
        name: i18n.t ('rms.film_released_date.three_years_ago_label'),
        id: new Date ().getFullYear () - 3,
      },
      {
        name: i18n.t ('rms.film_released_date.older_than_3_years_label'),
        id: new Date ().getFullYear () - 4,
      },
    ],
    film: null,
  };
}

const state = initialState ();

// actions

const actions = {
    async list(context) {
        var response = await API.tag.list();
        for (var key in response.tags) {
            if (response.tags.hasOwnProperty(key)) {
                context.commit('set_list', {
                    tags: response.tags[key],
                    tag_type: key
                });
            }
        }
        return response;
    },

    async listCountries(context) {
        var response = await API.tag.listCountries();
        context.commit('set_countries', {
            countries: response.countries
        })
    },

  async getTags (context, payload) {
    var response = await API.tag.getTags (payload);
    return response;
  },
};

// getters
const getters = {
  getField,
  getTagsofType: state => tag_type => {
    return state[tag_type];
  },
  getTag: state => (id, tag_type) => {
     var tag = state[tag_type].find(tag => {
            return tag.id == id;
        });
    return tag;
  },
  getTagsfromIds: (state, getters) => (tag_ids, tag_type) => {
    var tags = [];
        tag_ids.forEach(tag_id => {
            var tag = getters['getTag'](tag_id, tag_type);
            if (tag) {
                tags.push(tag);
            }
        });
        return tags;
  },
  getContractName: state => (value) => {
    var contract = DEFINES.TAG_TYPE.FILM_CONTRACT.find(tag => {
        return tag.value == value;
    });
    return contract.name;
}
};

// mutations
const mutations = {
  updateField,
  set_list(state, payload) {
    state[payload.tag_type] = payload.tags;
  },

  set_countries(state, payload) {
    state.film_countries = payload.countries;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
